import 'css-chunksrc/client/scenes/projectCreationForm/projectStatus/styles.scss';export default {
  "projectStatus": "_projectStatus_1ya1g_1",
  "selectedStatus": "_selectedStatus_1ya1g_6",
  "folderIcon": "_folderIcon_1ya1g_20",
  "name": "_name_1ya1g_26",
  "toggleArrow": "_toggleArrow_1ya1g_32",
  "menu": "_menu_1ya1g_39"
};